module.exports = __webpack_public_path__ + "static/faviconflapmax-d54d78ff6a10727af347ada82eddb3ca.png";